const menu = () => {

    submenuTabSwitch();

    jQuery(".header-dropdown-menu > .item > a.active").parent().addClass("active");
    jQuery(".header-dropdown-box-items > .item > a.active").closest(".parent").addClass("active");

    activeSubmenu();

    jQuery(".hey-mobile-nav-deeper-btn, .divider.deeper.parent > span").on("click", function() {
        jQuery(this).parent().find("button").toggleClass("active");
        jQuery(this).siblings(".hey-mobile-nav-child").toggleClass("active");
    });

    jQuery(".header-dropdown-nav .deeper.parent").on("mouseenter", function() {
        if (jQuery(window).width() > 1199) {
            jQuery("body").addClass("bg-over");
        }
    });

    jQuery(".header-dropdown-nav .deeper.parent").on("mouseleave", function() {
        if (jQuery(window).width() > 1199) {
            jQuery("body").removeClass("bg-over");
        }
    });


    mobileMenu();

};

const submenuTabSwitch = () => {

    let $sub_menu_items = jQuery(".header-dropdown-menu .header-dropdown-box-items .item");

    $sub_menu_items.closest(".header-dropdown-box").on("mouseleave", function(e) {
        activeSubmenu();
    });

    $sub_menu_items.on("mouseover", function(e) {

        let $this = jQuery(this);
        let index = $this.index();

        let $sub_menu_items_current_tab = $this.closest(".header-dropdown-box").find(".header-dropdown-box-items .item");
        let $sub_menu_contents = $this.closest(".header-dropdown-box").find(".header-dropdown-box-contents .content");

        $sub_menu_items_current_tab.removeClass("active");
        $sub_menu_contents.removeClass("active");

        $this.addClass("active");
        $sub_menu_contents.eq(index).addClass("active");

    });

};

const activeSubmenu = () => {

    let $active_item = jQuery(".header-dropdown-box-items > .item > a.active");

    $active_item.closest(".header-dropdown-box-items").find(".item").removeClass("active");
    $active_item.closest(".item").addClass("active");

    let index = $active_item.parent().index();
    let $sub_menu_contents = $active_item.closest(".header-dropdown-box").find(".header-dropdown-box-contents .content");

    $sub_menu_contents.removeClass("active");
    $sub_menu_contents.eq(index).addClass("active");

};

var body_margin = 0;

const fixedBody = (active_elem) => {

    let offset = document.scrollingElement.scrollTop;
    let $html = document.querySelector("html");
    let $body = document.querySelector("body");

    if (!hasClass(active_elem, "active")) {

        rmClass($html, "fixed-body");
        rmClass($body, "fixed-body");
        document.scrollingElement.scrollTop = body_margin;

    } 

    else {

        addClass($html, "fixed-body");
        addClass($body, "fixed-body");
        body_margin = offset;

    }

    $body.style.marginTop = offset * (-1) + "px";

};

const mobileMenu = () => {

    jQuery(".btn-expand").on("click", function() {

        let $this = jQuery(this);

        $this.closest(".parent").toggleClass("active");

    });

    jQuery(".btn-expand--hdb").on("click", function() {

        let $this = jQuery(this);

        $this.toggleClass("active");
        $this.siblings(".header-dropdown-box.hdb-2").toggleClass("active");

    });

    jQuery(".header-dropdown-box.hdb-2").find("a.active")
        .closest(".hdb-2").addClass("active")
        .siblings(".btn-expand--hdb").addClass("active")
        .closest(".item").removeClass("active")
        .closest(".item.parent").addClass("active");

    jQuery(".btn-menu-close").on("click", function() {
        jQuery("header").removeClass("up");
        jQuery(".btn-hamburger").removeClass("active");
        jQuery(".header-dropdown-nav").removeClass("active");
        jQuery("body").removeClass("bg-over");
        fixedBody(document.querySelector(".btn-hamburger"));
    });

    jQuery(".btn-hamburger").on("click", function() {
        jQuery("header").addClass("up");
        jQuery(".header-dropdown-nav").addClass("active");
        jQuery(".btn-hamburger").addClass("active");
        jQuery("body").addClass("bg-over");
        fixedBody(document.querySelector(".btn-hamburger"));
    });

    if (jQuery(".item.deeper.parent a.active").length < 1 && jQuery(window).width() < 1200) {
        jQuery(".item-services").addClass("active");
    }

};